export default "__VITE_ASSET__3tiq7bxp__"